/**
 * The `with[]` expansion every route-detail request uses.
 *
 * Extracted into one constant because the offline prefetch depends on producing a
 * byte-identical URL to the one RoutePage requests: the Workbox NetworkFirst cache
 * is keyed on the full URL including its query string, so a single differing
 * parameter means the prefetched entry is never found and the route is missing
 * offline — with no error anywhere to say so.
 *
 * `points` is deliberately absent: no call site passes it, and adding it here would
 * change the URL for every existing caller.
 */
export const ROUTE_DETAIL_PARAMS = { household: true, address: true } as const;

/**
 * The route-LIST request SavedRoutesPage makes on a first visit, with nothing in
 * the URL query string to override it (src/pages/SavedRoutesPage/index.tsx: the
 * effect at the top of the component, plus the `|| "25"` / `|| 1` state defaults).
 *
 * Same cache-key reasoning as ROUTE_DETAIL_PARAMS, and easier to get wrong: the
 * prefetch also asks for the list, but in bulk (perPage 500, no `address`) so it
 * can enumerate every route id. That is a different query string, so warming it
 * does nothing for the page — the routes end up cached but unreachable, with the
 * list screen empty offline and no error anywhere to explain it.
 *
 * SavedRoutesPage spreads this object into its own request so the two cannot
 * drift apart silently.
 */
export const SAVED_ROUTES_LIST_PARAMS = {
  address: true,
  page: 1,
  perPage: 25,
  searchValue: null,
} as const;
